(() => {
  function init() {
    const controls = document.querySelector('[data-hd-wind-filters]');
    const grid = document.getElementById('CollectionAjaxResult');
    if (!controls || !grid || controls.dataset.ready) return;
    const data = JSON.parse(controls.querySelector('[data-hd-filter-data]').textContent);
    const copy = JSON.parse(controls.querySelector('[data-hd-filter-copy]').textContent);
    const height = controls.querySelector('[data-hd-height]');
    const color = controls.querySelector('[data-hd-color]');
    const status = controls.querySelector('[data-hd-filter-count]');
    const empty = controls.querySelector('[data-hd-filter-empty]');
    const storageKey = 'hd-wind-filters:' + location.pathname;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      if ([...height.options].some(option => option.value === saved.height)) height.value = saved.height;
      if ([...color.options].some(option => option.value === saved.color)) color.value = saved.color;
    } catch {}
    const matches = (item) => {
      if (!height.value && !color.value) return true;
      if (!item) return false;
      const size = item.height <= 100 ? 'small' : item.height <= 140 ? 'medium' : 'large';
      return (!height.value || height.value === size) && (!color.value || item.colors.includes(color.value));
    };
    const update = () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify({height:height.value,color:color.value})); } catch {}
      let count = 0;
      grid.querySelectorAll('[data-product-handle]').forEach(card => {
        const show = matches(data[card.dataset.productHandle]);
        if (card.hidden === show) card.hidden = !show;
        if (show) count += 1;
      });
      status.textContent = copy.count.replace('__COUNT__', String(count));
      empty.hidden = count !== 0;
    };
    controls.dataset.ready = 'true';
    controls.hidden = false;
    controls.addEventListener('change', update);
    controls.querySelector('[data-hd-reset]').addEventListener('click', () => {
      height.value = ''; color.value = ''; update();
    });
    new MutationObserver(update).observe(grid, {childList: true, subtree: true});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();